import { Button, Dialog } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useCart } from "./cart.context";

export function CartFooter() {
	const { clearCart, isLoading } = useCart();

	const { t } = useTranslation(["common", "cart"]);

	return (
		<div className="flex flex-col gap-4 px-4 md:px-6">
			<div className="flex gap-2 justify-center items-start">
				<Dialog.Root>
					<Dialog.Trigger asChild>
						<Button
							className="text-gray-500 py-4"
							variant="ghost"
							size="fit"
							data-testid="cart-clear-button"
						>
							{t("clearCart", { ns: "cart" })}
						</Button>
					</Dialog.Trigger>

					<Dialog.Content data-testid="cart-clear-dialog">
						<Dialog.Header>
							<Dialog.Title>
								{t("doYouWantToClearYourCart?", { ns: "cart" })}
							</Dialog.Title>
							<Dialog.Description>
								{t("doYouWantToClearYourCart?description", { ns: "cart" })}
							</Dialog.Description>
						</Dialog.Header>

						<Dialog.Footer variant="vertical">
							<Button
								className="flex-grow"
								size="md"
								variant="primary"
								onClick={clearCart}
								pending={isLoading}
								data-testid="cart-clear-button-yes"
							>
								{t("yes")}
							</Button>

							<Dialog.Close className="flex-grow" asChild>
								<Button
									size="md"
									variant="secondary"
									data-testid="cart-clear-button-no"
									disabled={isLoading}
								>
									{t("no")}
								</Button>
							</Dialog.Close>
						</Dialog.Footer>
					</Dialog.Content>
				</Dialog.Root>
			</div>
		</div>
	);
}
